module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/125NJiY/tc-custom/9781504089593.jpg?1741151480389",
      "alt": "This image is the cover for the book Serial Killer's Son"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Serial Killer's Son\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("He survived—but can he ever truly escape? A chilling psychological novel about damage, desperation, and a man trapped by childhood trauma.")]), _c('br'), _c('br'), _vm._v(" When Monty was a child, he killed his father. His father had been kidnapping and murdering women for years, and forcing Monty to help. Monty survived—physically. He was adopted by a wonderful, caring family and is now a wealthy and successful man. On the outside."), _c('br'), _c('br'), _vm._v(" But now, the last of his adoptive family has died. Monty lives alone in his beautiful manor house in rural northern England, and the closest thing he has to a friend is his faithful employee, George."), _c('br'), _c('br'), _vm._v(" Monty has tried to live a good life, but his father’s deeds haunt him. And with each passing day he’s finding it more difficult to fight against the blood that runs through his veins . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Charlotte Stevenson\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0